/* eslint-disable */
export default {
  infoMessageMins:
    'Tallenna loki automaattisesti {delayTime} minuutin kuluttua...',
  infoMessageMin:
    'Tallenna loki automaattisesti {delayTime} minuutin kuluttua...',
  infoMessageSecs:
    'Tallenna loki automaattisesti {delayTime} sekunnin kuluttua...',
  infoMessageSec:
    'Tallenna loki automaattisesti {delayTime} sekunnin kuluttua...',
} as const;

// @key: @#@"infoMessageMins"@#@ @source: @#@"Auto-save log in {delayTime} minutes..."@#@
// @key: @#@"infoMessageMin"@#@ @source: @#@"Auto-save log in {delayTime} minute..."@#@
// @key: @#@"infoMessageSecs"@#@ @source: @#@"Auto-save log in {delayTime} seconds..."@#@
// @key: @#@"infoMessageSec"@#@ @source: @#@"Auto-save log in {delayTime} second..."@#@
